DialogAutocompleteCtrl.$inject = ['$log', '$http', '$q', '$scope'];

export default function DialogAutocompleteCtrl($log, $http, $q, $scope) {
    var dau = this;
    let modelId = $scope.model.id_model;

    dau.jsonCampoExtra = $scope.model.campoExtra;
    dau.campoExtraValor = $scope.model.campoExtraValor;
    dau.dialogHandler = $scope.dialog;

    dau.options = [];
    dau.searchText = '';
    dau.loading = true;

    function cargarOptions(text) {
        dau.loading = true;

        let params = {model_id: modelId};
        if (text.length > 0) params.search = text;

        return $http({
            method: 'GET',
            url: dau.jsonCampoExtra.url,
            headers: dau.jsonCampoExtra.headers,
            params: params
        }).success(function (data, status, headers, config) {
            dau.options = data;
            dau.loading = false;
        }).error(function (data, status, headers, config) {
            alert("Ha fallado la petición. Estado HTTP:" + status);
            dau.loading = false;
        });
    }

    cargarOptions('');

    dau.textOption = function (option) {
        return option[dau.jsonCampoExtra.text] + " " + option[dau.jsonCampoExtra.descrip];
    };

    dau.esElSeleccionado = function (option) {
        return option[dau.jsonCampoExtra.key] == dau.campoExtraValor;
    };

    dau.search = function () {
        cargarOptions(dau.searchText);
    };

    dau.close = function () {
        dau.dialogHandler.cancel();
    };

    dau.seleccionar = function (option) {
        if (!dau.esElSeleccionado(option)) {
            $scope.model.selected = option;
            dau.dialogHandler.close(option);
        }
    };
}